import styled, { css } from "styled-components";

import DefaultMenuList from "@material-ui/core/MenuList";
import {
  MenuItem as DefaultMenuItem,
  Popper as DefaultPopper,
} from "@material-ui/core";

import { COLORS } from "constants/colorScheme";

export const Popper = styled(DefaultPopper)`
  && {
    z-index: 1000;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  max-width: 360px;
`;

export const MenuList = styled(DefaultMenuList)`
  && {
    overflow-y: auto;
    max-height: 280px;
    padding: 4px 0;
    border-radius: 8px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }
  }

  && .MuiListItem-root {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: 0px;
    padding: 8px 16px;

    border-radius: 0px;
    color: ${COLORS.BLACK};

    &:hover {
      color: ${COLORS.CYAN};
      background-color: ${COLORS.CYAN_LIGHT_20};
    }
  }

  && .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: ${COLORS.WHITE};
    color: ${COLORS.CYAN};
    border-bottom: 2px solid ${COLORS.CYAN};
  }

  && .MuiListItemText-root {
    display: flex;
    align-items: center;
  }
`;

export const MenuItemWrapper = styled.div``;

export const MenuItem = styled(DefaultMenuItem)`
  &&& {
    ${({ isNestedMenu }: { isNestedMenu?: boolean }) =>
      isNestedMenu &&
      css`
        padding-left: 32px;
      `};
  }
`;

export const IconContainer = styled.div`
  margin-left: 8px;
`;

export const CheckedIcon = styled.div`
  display: flex;

  & path,
  & use {
    fill: ${COLORS.CYAN};
  }
`;

export const IconGap = styled.div`
  width: 24px;
  height: 24px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 20px 16px;
  border-top: 1px solid #e0e0e0;
  background-color: white;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;
